"use client";
import { PropsWithChildren } from "react";

import { View } from "@ctv/shared-core/src";
import BlankHeader from "@ctv/shared/components/Layout/BlankHeader";

import { useCheckMFAGateway } from "@ctv/app/[locale]/(post-login)/_hooks/useCheckMFAGateway";
import { FC_COMPROMISED_PASSWORD } from "../feature-control/constants";
import useFeatureControlSegmentation from "../feature-control/hooks";
import AuthLoading from "./AuthLoading";
import FlaggedUserError from "./components/FlaggedUserError";
import MfaGatewayApiError from "./components/mfa-otp/MfaGatewayApiError";
import OtpField from "./components/mfa-otp/OtpField";

export const MAX_OTP_LENGTH = 6;

export default function CheckMfaGateway({
  children,
}: PropsWithChildren<unknown>) {
  const {
    data: { data, isError, isByPass, errorMessage },
    refOtp,
    isSubmitting,
    onSendOtp,
    onSubmitOtp,
  } = useCheckMFAGateway();

  const { enabled: isEnabledCompromisedPasswordCheck } =
    useFeatureControlSegmentation(FC_COMPROMISED_PASSWORD);

  if (data === undefined) {
    return <AuthLoading />;
  }

  if (data === null) {
    return <MfaGatewayApiError />;
  }

  if (isEnabledCompromisedPasswordCheck && data.flagged) {
    return <FlaggedUserError />;
  }

  if (!data.mfaGate || isByPass) {
    return <>{children}</>;
  }

  return (
    <View style={styles.background} align="center" spacing="xxl" flex>
      <BlankHeader />
      <OtpField
        otpRef={refOtp}
        otpMaxLength={MAX_OTP_LENGTH}
        isError={isError}
        errorMessage={errorMessage}
        isSubmitting={isSubmitting}
        onComplete={onSubmitOtp}
        onResendOtp={onSendOtp}
      />
    </View>
  );
}

const styles = {
  background: {
    backgroundColor: "rgba(11, 11, 11,0.6)", // 0B0B0B Bloom Overlay Scrims converted to rgba
  },
};
